// extracted by mini-css-extract-plugin
export default {"stack":"UOSnZs_G0pYW0EDEwM90","card":"nAZrbCjaWKfceHqlHn05","cardImage":"HXIBzES8Sg6yBO4hNgrc","cardSkeleton":"GBa1lxfOxQqUHftoNJ3W"};